// extracted by mini-css-extract-plugin
module.exports = {"news":"News_news__3--bm","items":"News_items__4NSR3"};